/**
 * useResultSlider - Hook to display lottery result cards on the home page
 *
 */
import { useSelector } from 'react-redux'
import { RootState } from '@/redux/reducers'
import { useMemo, ReactNode } from 'react'
import { Game } from '@/redux/reducers/gameReducer'

import ResultCard from '@/component/ResultCard'

const useResultSlider = () => {
  const results = useSelector((state: RootState) => state.games.results)

  const resultCards = useMemo(() => {
    const cards: ReactNode[] = []

    if (!results || results.length === 0) {
      return cards
    }

    // Process each result game
    results.forEach((game: Game) => {
      if (!game.rounds || game.rounds.length === 0) {
        return
      }

      cards.push(<ResultCard key={game.id} game={game} />)
    })

    return cards
  }, [results])

  return resultCards
}

export default useResultSlider
